import { TranslateService } from '@ngx-translate/core';

let translateServiceRef: TranslateService | undefined;

export function setTranslateServiceRef(service: TranslateService): void {
  translateServiceRef = service;
}

export function translateInstant(
  key: string,
  params?: Record<string, unknown>
): string {
  return translateServiceRef?.instant(key, params) ?? key;
}
